import { useEffect } from "react";
import { useSetAtom } from "jotai";

import { selectedAnnotationsAtom } from "../atoms/measurementAtoms";
import { getCornerstone, getCornerstoneTools } from "../utils/dicomLoader";

// Subscribes to Cornerstone3D's ANNOTATION_SELECTION_CHANGE event and mirrors
// the selected-annotation UIDs into a jotai atom. Mount once at the viewer
// root (CaseViewer) so React-side consumers (deleteSelectedAnnotation command,
// future UI affordances) can read selection without polling Cornerstone.
export const useAnnotationSelectionMirror = () => {
  const setSelected = useSetAtom(selectedAnnotationsAtom);

  useEffect(() => {
    let cs;
    let csTools;
    try {
      cs = getCornerstone();
      csTools = getCornerstoneTools();
    } catch {
      return;
    }

    const onChange = () => {
      try {
        const uids = csTools.annotation.selection.getAnnotationsSelected();
        setSelected(Array.from(uids ?? []));
      } catch {
        setSelected([]);
      }
    };

    // Cornerstone3D dispatches selection changes on core.eventTarget with
    // the value of csTools.Enums.Events.ANNOTATION_SELECTION_CHANGE
    // ("CORNERSTONE_TOOLS_ANNOTATION_SELECTION_CHANGE"). The previous
    // hard-coded "ANNOTATION_SELECTION_CHANGE" was the enum KEY, not the
    // VALUE — the listener never fired, the atom stayed [], and the
    // Delete-key + right-click→Clear paths (which read this atom) thought
    // nothing was selected.
    const eventName = csTools.Enums?.Events?.ANNOTATION_SELECTION_CHANGE;
    if (!eventName) return;
    cs.eventTarget.addEventListener(eventName, onChange);
    return () => {
      cs.eventTarget.removeEventListener(eventName, onChange);
    };
  }, [setSelected]);
};
